import {SurchargeGroupList} from "./SurchageGroupList.tsx";
import {useDialogFormContext} from "../../../../components/DialogFormContext.ts";
import Dialog from "@rio-cloud/rio-uikit/Dialog";
import {SurchargeGroupForm} from "./SurchargeGroupForm.tsx";

export const SurchargeGroupConfiguration = () => {
    const {showDialog, closeDialog, currentId} = useDialogFormContext()



    return <>
        <Dialog show={showDialog}
                onClose={closeDialog}
                title={currentId ? "Update Surcharge Group" : "Create Surcharge Group"}
                body={<SurchargeGroupForm id={currentId} onCancel={closeDialog}/>}
                />
        <h1>Surcharge Groups</h1>
        <SurchargeGroupList/>
    </>
}